import { useRef } from 'react';

import { Search, X } from 'lucide-react';

import {
    InputGroup,
    InputGroupAddon,
    InputGroupButton,
    InputGroupInput,
} from '@nesso/ui/primitives/input-group';

import { useReportingSearchInput } from '../../model/use-reporting-search-input';

// The clear control appears once the field holds text and routes through the same debounced
// `onChange` a manual delete would use.
export function ReportingPageSearch() {
    const { value, onChange } = useReportingSearchInput();
    const inputRef = useRef<HTMLInputElement>(null);

    // The button unmounts once the field is empty, so focus moves first or it falls to the body.
    const clear = () => {
        inputRef.current?.focus();
        onChange('');
    };

    return (
        <InputGroup variant="underline" className="h-16 w-full">
            {/* py-3 brings the addon's own padding to 12px; the group's height supplies the
                remaining 8px of slack. */}
            <InputGroupAddon className="py-3">
                <Search className="size-6" aria-hidden="true" />
            </InputGroupAddon>
            <InputGroupInput
                ref={inputRef}
                type="text"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                aria-label="Search practice members"
            />
            {value && (
                <InputGroupAddon align="inline-end">
                    <InputGroupButton size="icon-sm" aria-label="Clear search" onClick={clear}>
                        <X className="size-4.5" aria-hidden="true" />
                    </InputGroupButton>
                </InputGroupAddon>
            )}
        </InputGroup>
    );
}
